/**
 * Mapa único dos endpoints. O front usa estes caminhos; a API registra exatamente estes.
 * Adicionar endpoint: acrescente uma linha aqui (append-only) e documente no ADR se mudar um existente.
 */
export const endpoints = {
  health: '/api/health',

  authConfig: '/api/auth/config',
  signup: '/api/auth/signup',
  login: '/api/auth/login',
  logout: '/api/auth/logout',
  me: '/api/auth/me',
  changePassword: '/api/auth/password',

  trips: '/api/trips',
  trip: (id: string) => `/api/trips/${encodeURIComponent(id)}`,

  routes: '/api/routes',
  route: (id: string) => `/api/routes/${encodeURIComponent(id)}`,
  routeCheck: (id: string) => `/api/routes/${encodeURIComponent(id)}/check`,

  alerts: '/api/alerts',

  telegram: '/api/telegram',
  telegramWebhook: '/api/telegram/webhook',
  telegramTest: '/api/telegram/test',
} as const;
